/**
 * Una card del dettaglio e dell'esecuzione di un test, su sfondo grigio col
 * titolo al centro, come le card delle schede: l'icona, il titolo e, se c'è,
 * un conteggio. Riempie l'altezza della riga della griglia, così due card
 * affiancate finiscono allo stesso punto.
 */

import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function CardSezione({
  titolo,
  Icona,
  conteggio,
  children,
}: {
  titolo: string;
  Icona: LucideIcon;
  conteggio?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card className="h-full bg-muted">
      <CardHeader>
        <CardTitle className="flex items-center justify-center gap-2 font-semibold tracking-wide uppercase">
          <Icona aria-hidden className="size-5" />
          <h2>{titolo}</h2>
          {conteggio !== undefined && <Badge className="tabular-nums">{conteggio}</Badge>}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-3 px-2 @xl:px-(--card-spacing)">
        {children}
      </CardContent>
    </Card>
  );
}
